import moment from 'helpers/moment'
import React from 'react'
import {Link, useHistory} from 'react-router-dom'
import clsx from 'clsx'
import { makeStyles, withStyles} from 'external/material'
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Chip from '@mui/material/Chip'
import Checkbox from '@mui/material/Checkbox'
import {createPost} from '../../../helpers/command'
import {toDisplayPoints} from '../../../helpers/utils'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faEye, faPoll} from "@fortawesome/free-solid-svg-icons"


const useStyles = makeStyles(bodyStyles)

export default function AssignmentAssessmentsBody({context}) {

  const classes = useStyles()
  const history = useHistory()
  const {quizAssignments, translate, link, query, assignmentId, standardsContext} = context

  const {assessmentStandards} = standardsContext 

  const standardsFound = assessmentStandards.items.length > 0;

  function formatDate (date) {
    return moment(date).format(context.languageId == 'es' ? 'DD/MM/YYYY' : 'MM/DD/YYYY')
  }

  return (
    <Table className={clsx(classes.studentAssessmentsTable)}>
      <TableHead>
        <TableRow>
          <TableCell className={clsx(classes.studentHeading)}>{translate('student')}</TableCell>
          <TableCell className={clsx(classes.studentHeading)}>{translate('assessment-start-date')}</TableCell>
          <TableCell className={clsx(classes.studentHeading)}>{translate('assessment-sent-date')}</TableCell>
          <TableCell className={clsx(classes.studentHeading)}>{translate('points')}</TableCell>
          <TableCell className={clsx(classes.studentHeading)}>{translate('total')}</TableCell>
          <TableCell className={clsx(classes.studentHeading)} align="center" >{translate('status')}</TableCell>
          <TableCell className={clsx(classes.studentHeading)} align="center" >{translate('state')}</TableCell>
          <TableCell/>
        </TableRow>
      </TableHead>
      <TableBody>
        {context.quizStudentAssessments.map((studentAssessment, index) => {

          const {id, results, finished, started, properties = {}} = studentAssessment
          const {bonus = 0, published = false} = properties
          const {points, total, pending} = Object.values(results || {}).reduce((acc, result) => {
            return {points: acc.points + result.points, total: acc.total + result.total, pending: acc.pending + (result.pending ? 1 : 0)}
          }, {points: bonus || 0, total: 0, pending: 0})

          function savePageReference () {
            context.setState({quizEditFrom: link({assignmentId}, '/:languageId/:role/:page/:tab/:assignmentId'), quizEditFromQuery: {...query}})
          }

          function saveToPdf() {
            context.updateState({quizAssessmentForPdfId: {$set: id}})
          }

          const status = (!finished && 'started') || (pending > 0 && 'pending-review') || (published && 'published') || 'not-published'

          const stateDisabled = ['pending-review','started'].indexOf(status) >= 0 ? {disabled: true, inputProps: {'aria-label': 'disabled checkbox'}} : {}

          async function handleStateChange (e) {
            const updated = await context.updateState({ quizStudentAssessments: { [index]: { properties: { published: {$set: e.target.checked}} }} })
            const {id, properties} = updated.quizStudentAssessments[index]
            createPost('quiz','saveReviewProperties')({id, properties})
          }

          return (
          <TableRow key={studentAssessment.id} className={clsx(classes.row, "student")}>
            <TableCell className={clsx(classes.studentCell, "name")}>
              {studentAssessment.studentName}
            </TableCell>
            <TableCell className={clsx(classes.studentCell, "started")}>
              {formatDate(started)}
            </TableCell>
            <TableCell className={clsx(classes.studentCell, "finished")}>
              {finished && formatDate(finished)}
            </TableCell>
            <TableCell className={clsx(classes.studentCell, "points")}>
              {finished && toDisplayPoints(points)}
            </TableCell>
            <TableCell className={clsx(classes.studentCell, "total")}>
              {finished && total}
            </TableCell>
            <TableCell className={clsx(classes.studentCell, "status")} align="center">
              <Chip label={translate(`${status}-chip`)} className={clsx(classes.statusChip, {[status]: true})} />
            </TableCell>
            <TableCell className={clsx(classes.studentCell, "state")} align="center">
              <Checkbox {...stateDisabled} color="primary" checked={status == 'published'} onChange={handleStateChange} />
            </TableCell>
            <TableCell className={clsx(classes.studentCell, "actions")} align="right" scope="row" >
              <Box className="actionsContainer">
                {status != 'started' && (
                  <Tooltip title={translate('review-assessment-tooltip')}>
                    <Link
                      onClick={savePageReference}
                      to={link({assessment: id, action: 'review'}, '/:languageId/:role/:page/:assessment/:action')}
                      className={clsx(classes.studentLink, "review")}
                    >
                      <FontAwesomeIcon icon={faEye} />
                    </Link>
                  </Tooltip>
                )}
                {status != 'started' && (
                  <Tooltip title={translate('standards-results-tooltip')}>
                    <Link
                      onClick={savePageReference}
                      to={link({assessment: id, action: 'standards-results'}, '/:languageId/:role/:page/:assessment/:action')}
                      className={clsx(classes.studentLink, !standardsFound ? classes.linkDisabled : '')}
                    >
                       <FontAwesomeIcon icon={faPoll} /> 
                    </Link>
                  </Tooltip>
                )}
               </Box>
            </TableCell>
          </TableRow>
        )})}
      </TableBody>
    </Table>
  )
}


function bodyStyles(theme) {
  // removed-dreyfous-filter context.profile.domain == 'dreyfous' && (

  const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  }

  return {
    row: {
      '&:hover': {
      backgroundColor: '#def2ff'
    },
    },
    title: {
      paddingLeft: 8
    },
    titleContainer: {
      display: 'flex'
    },
    assessmentIcon: {
      ...verticalCentering,
      marginTop: -5,
      marginRight: 15
    },
    titleText: {
      ...verticalCentering,
      color: '#ff3a3a',
      "&.validated": {
      color: '#000'
    }
    },
      expand: {
      marginRight: 8,
      visibility: 'hidden',
      '&.visible': {
      visibility: 'visible'
    }
    },
      statusWrapper: {
      display: 'flex',
      justifyContent: 'center',
    },
    statusDot: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center',
      width: 20,
      height: 20,
      fontSize: '9pt',
      color: '#fff',
      backgroundColor: '#00bbe7',
      "& > span": {
      marginTop: 1,
      marginLeft: 1
    },
    "& > svg": {
      fontSize: '11.5pt'
    },
    "&.pending" : {
      backgroundColor: '#ff3a3a'
    }
    },
      links: {
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'flex-end'
    },
    link: {
      color: '#009dd8',
      fontSize: '16pt',
      marginRight: 20,
      width: 25,
      cursor: 'pointer',
      ...verticalCentering
    },
    sharedLink: {
      display: 'flex',
      marginRight: 20,
      color: '#4d586e'
    },
    sharedIcon: {
      ...verticalCentering,
      color:'#c4c4c4', 
      marginRight: 10,
      '&.shared': {
      color: '#ea8511'
    }
    },
    sharedText: {
      ...verticalCentering,
      cursor: 'default',
      textAlign: 'center',
      marginRight: 10,
      width: 50
    },
    moreSettingsButton: {
      color: '#a2a6b2',
      cursor: 'pointer'
    },
    studentAssessments: {
      padding: 0,
      backgroundColor: '#f5f9fa',
    },
    studentHeading: {
      color: '#707789',
      fontWeight: 'bold'
    },
    studentCell: {
      borderBottom: 0,
      '&.points.pending': {
      color: '#e91010'
      },
      '&.actions': {
        '& .actionsContainer': {
          display: 'flex',
          padding: '5px 7px',
          flexGrow: '1',
          justifyContent: 'flex-end'
        }
      }
    },
    statusChip: {
      color: "#fff",
      fontSize: '9pt',
      padding: '5px 7px',
      "&.pending-review": {
        backgroundColor: "#ef3a3a"
      },
      "&.published": {
        backgroundColor: "#43b869"
      },
      "&.not-published": {
        backgroundColor: "#00bbe7"
      },
      "&.started": {
        backgroundColor: "#00bbe7"
      }
    },
    studentLink: {
      color: '#009dd8',
      textDecoration: 'none',
      fontSize: '1.9em',
      cursor: 'pointer',
      margin: '0 7px',
      ...verticalCentering
    },
    linkDisabled: {
      cursor: 'default',
      opacity: '0.5',
      textDecoration: 'none',
      pointerEvents: 'none'
    } 
  }
}
